module.exports = __webpack_public_path__ + "img/notes.4e3c8bd7.png";